import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import ManagedSelect from "@/components/ManagedSelect";
import { Tags } from "lucide-react";
import { Field } from "./Field";

export function EnrichmentFields({ form, setField, lists, addOption }) {
  return (
    <section className="border border-border bg-card p-5 space-y-4">
      <div className="flex items-center gap-2">
        <Tags className="h-4 w-4 text-primary" />
        <h2 className="font-heading text-lg font-medium">Anreicherung</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <ManagedSelect
            label="Zweck"
            testId="select-purpose"
            value={form.purpose}
            onChange={(v) => setField("purpose", v)}
            options={lists.purpose}
            onAdd={(v) => addOption("purpose", v)}
          />
          {form.purpose === "Sonstiges" && (
            <Input
              value={form.purpose_other}
              onChange={(e) => setField("purpose_other", e.target.value)}
              placeholder="Zweck angeben…"
              className="bg-white animate-fade-up"
              data-testid="input-purpose-other"
            />
          )}
        </div>
        <div className="space-y-2">
          <ManagedSelect
            label="Durchgeführt von"
            testId="select-performed-by"
            value={form.performed_by}
            onChange={(v) => setField("performed_by", v)}
            options={lists.person}
            onAdd={(v) => addOption("person", v)}
          />
          {form.performed_by === "Sonstiges" && (
            <Input
              value={form.performed_by_other}
              onChange={(e) => setField("performed_by_other", e.target.value)}
              placeholder="Person/Firma angeben…"
              className="bg-white animate-fade-up"
              data-testid="input-performed-by-other"
            />
          )}
        </div>
        <div className="space-y-2">
          <ManagedSelect
            label="Bezahlt von"
            testId="select-paid-by"
            value={form.paid_by}
            onChange={(v) => setField("paid_by", v)}
            options={lists.person}
            onAdd={(v) => addOption("person", v)}
          />
          {form.paid_by === "Sonstiges" && (
            <Input
              value={form.paid_by_other}
              onChange={(e) => setField("paid_by_other", e.target.value)}
              placeholder="Person/Firma angeben…"
              className="bg-white animate-fade-up"
              data-testid="input-paid-by-other"
            />
          )}
        </div>
        <div className="space-y-2">
          <ManagedSelect
            label="Bezahlt mit"
            testId="select-paid-with"
            value={form.paid_with}
            onChange={(v) => setField("paid_with", v)}
            options={lists.payment_method}
            onAdd={(v) => addOption("payment_method", v)}
          />
          {form.paid_with === "Sonstiges" && (
            <Input
              value={form.paid_with_other}
              onChange={(e) => setField("paid_with_other", e.target.value)}
              placeholder="Zahlungsmittel angeben…"
              className="bg-white animate-fade-up"
              data-testid="input-paid-with-other"
            />
          )}
        </div>
      </div>
      <Field label="Notiz (optional)">
        <Textarea
          value={form.note}
          onChange={(e) => setField("note", e.target.value)}
          placeholder="Zusätzliche Bemerkung…"
          className="bg-white"
          data-testid="input-note"
        />
      </Field>
    </section>
  );
}
